import { render, staticRenderFns } from "./batchReview.vue?vue&type=template&id=2b467b5d&scoped=true"
import script from "./batchReview.vue?vue&type=script&lang=ts"
export * from "./batchReview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b467b5d",
  null
  
)

export default component.exports